// src/components/CropImageHelper.js

function getRadianAngle(degreeValue) {
  return (degreeValue * Math.PI) / 180;
}

function rotateCropBox(crop, imgW, imgH, rotation) {
  switch ((rotation + 360) % 360) {
    // Saat yönünde 90°
    case 90:
      return {
        x: crop.y,
        y: imgW - crop.x - crop.width,
        width: crop.height,
        height: crop.width
      };
    // 180°
    case 180:
      return {
        x: imgW - crop.x - crop.width,
        y: imgH - crop.y - crop.height,
        width: crop.width,
        height: crop.height
      };
    // Saat yönünde 270°  (‑90°)
    case 270:
      return {
        x: imgH - crop.y - crop.height,
        y: crop.x,
        width: crop.height,
        height: crop.width
      };
    // 0°
    default:
      return crop;
  }
}


function rotateSize(width, height, rotation) {
  const rotRad = getRadianAngle(rotation);
  return {
    width:
      Math.abs(Math.cos(rotRad) * width) +
      Math.abs(Math.sin(rotRad) * height),
    height:
      Math.abs(Math.sin(rotRad) * width) +
      Math.abs(Math.cos(rotRad) * height),
  };
}

function createImage(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = url;
    img.onload = () => resolve(img);
    img.onerror = (err) => reject(err);
  });
}

export default async function getCroppedImg(
  imageSrc,
  pixelCrop,
  rotation = 0,
  fileName = "cropped.webp",
  outputWidth = 800,
  outputHeight = 600,
  mimeType = "image/webp"
) {
  const image = await createImage(imageSrc);
  const rotRad = getRadianAngle(rotation);

  const { width: safeW, height: safeH } = rotateSize(
    image.width,
    image.height,
    rotation
  );
  const safeCanvas = document.createElement("canvas");
  safeCanvas.width = safeW;
  safeCanvas.height = safeH;
  const sCtx = safeCanvas.getContext("2d");

  sCtx.translate(safeW / 2, safeH / 2);
  sCtx.rotate(rotRad);
  sCtx.translate(-image.width / 2, -image.height / 2);
  sCtx.drawImage(image, 0, 0);

  const srcX = pixelCrop.x;
  const srcY = pixelCrop.y;
  const srcW = pixelCrop.width;
  const srcH = pixelCrop.height;

  const finalCanvas = document.createElement("canvas");
  finalCanvas.width = outputWidth;
  finalCanvas.height = outputHeight;
  const fCtx = finalCanvas.getContext("2d");

  fCtx.fillStyle = "#fff";
  fCtx.fillRect(0, 0, outputWidth, outputHeight);

  const scale = Math.max(outputWidth / srcW, outputHeight / srcH);

  fCtx.drawImage(
    safeCanvas,
    srcX,
    srcY,
    srcW,
    srcH,
    0,
    0,
    srcW * scale,
    srcH * scale
  );

  return new Promise((resolve) => {
    finalCanvas.toBlob(
      (blob) => {
        if (blob) {
          const newFileName = fileName.replace(/\.\w+$/, mimeType === "image/webp" ? ".webp" : ".jpg");
          resolve(new File([blob], newFileName, { type: mimeType }));
        } else {
          console.error("Blob oluşturulamadı. WebP desteklenmiyor olabilir.");
          resolve(null);
        }
      },
      mimeType,
      0.92
    );
  });
}
